<template>
  <Row>
    <Col span="24">
    <Card>
      <p slot="title">研究列表</p>
      <span slot="extra">
        <Select v-model="type" style="width:90px" @on-change="fetchData" placeholder="研究对象" clearable>
          <Option v-for="(type,key) in types" :value="key" :key="key">{{ type }}</Option>
        </Select>
        <Select v-model="masking" style="width:70px" @on-change="fetchData" placeholder="盲法" clearable>
          <Option v-for="(masking,key) in maskings" :value="key" :key="key">{{ masking }}</Option>
        </Select>
        <Select v-model="random" style="width:120px" @on-change="fetchData" placeholder="随机方案" clearable>
          <Option v-for="(random,key) in randoms" :value="key" :key="key">{{ random }}</Option>
        </Select>
        <Select v-model="phase" style="width:120px" @on-change="fetchData" placeholder="研究分期" clearable>
          <Option v-for="(phase,key) in phases" :value="key" :key="key">{{ phase }}</Option>
        </Select>
        <Select v-model="status" style="width:80px" @on-change="fetchData" placeholder="状态" clearable>
          <Option v-for="(status,key) in statuses" :value="key" :key="key">{{ status }}</Option>
        </Select>
        <Input v-model="queryStr" placeholder="请输入关键词查询" @on-change="fetchData" style="width: 160px"></Input>
        <Button type="success" @click="showAdd = true"><Icon type="md-add-circle"></Icon> 添加研究</Button>
      </span>
      <Row>
        <Col span="6" v-for="study in studys" :key="study.id" style="padding: 5px;">
          <study-item ref="studyItem" :model="study" @refresh="refresh" @edit="edit" @auth="auth">
          </study-item>
        </Col>
      </Row>
      <pagination v-bind:meta="pageMeta" name="pagination" @refresh="fetchData"></pagination>
    </Card>
    <Modal
        v-model="showAdd"
        title="添加研究"
        width="720"
        :styles="{bottom:'0px'}" >
        <add-study ref="addStudy" @refresh="refresh"></add-study>
        <div slot="footer" v-show="false"></div>
    </Modal>
    <Modal
        v-model="showEdit"
        title="编辑研究信息"
        width="720"
        :styles="{bottom:'0px'}" >
        <edit-study ref="editStudy" :meta="meta" @refresh="refresh"></edit-study>
        <div slot="footer" v-show="false"></div>
    </Modal>
    <Modal
        v-model="showAuth"
        title="授权研究者"
        :styles="{bottom:'0px'}" >
        <auth-admin ref="authAdmin" :meta="meta" @refresh="refresh"></auth-admin>
        <div slot="footer" v-show="false"></div>
    </Modal>
    </Col>
  </Row>
</template>

<script>
import { ListStudys, GetAssistItems, DeleteStudy } from '@/api/study'
import AddStudy from '@/components/study/AddStudy'
import EditStudy from '@/components/study/EditStudy'
import Pagination from '@/components/share/Pagination'
import StudyItem from '@/components/study/StudyItem'
import AuthAdmin from '@/components/study/AuthAdmin'

export default {
  name: 'lsit-studys',
  data: function () {
    return {
      studys: [],
      queryStr: '',
      meta: '',
      showAdd: false,
      showEdit: false,
      showAuth: false,
      pageMeta: {},
      status: null,
      statuses: {},
      type: null,
      types: {},
      masking: null,
      maskings: {},
      random: null,
      randoms: {},
      phase: null,
      phases: {}
    }
  },
  components: {
    'pagination': Pagination,
    'add-study': AddStudy,
    'edit-study': EditStudy,
    'study-item': StudyItem,
    'auth-admin': AuthAdmin
  },
  created: function () {
    this.fetchData()
    this.getItems()
  },
  methods: {
    fetchData: function (page = 1) {
      var query = this.$router.currentRoute.query
      query['page'] = page
      query['StudySearch[status]'] = this.status
      query['queryStr'] = this.queryStr
      ListStudys(query).then(async res => {
        this.studys = res.items
        this.pageMeta = res._meta
      })
    },
    getItems: function () {
      GetAssistItems().then(async res => {
        this.statuses = res.statuses
        this.types = res.types
        this.maskings = res.maskings
        this.randoms = res.randoms
        this.phases = res.phases
      })
    },
    refresh: function () {
      this.fetchData()
      this.showAdd = false
      this.showEdit = false
      this.showAuth = false
    },
    edit: function (id) {
      this.meta = id
      this.$refs.editStudy.init(id)
      this.showEdit = true
    },
    auth: function (id) {
      this.meta = id
      this.$refs.authAdmin.init(id)
      this.showAuth = true
    },
    remove: function (id) {
      DeleteStudy(id).then(async res => {
        this.fetchData()
      })
    }
  }
}
</script>
